import { StyleSheet } from "react-native";
import { AppTheme } from "../../theme";
import { appColors } from "../../appTheme";

export const staffListStyle = (theme: AppTheme) => StyleSheet.create({
    pageContainer: {
        flex: 1,
        backgroundColor: appColors.lightBackgroundColor
    },
    headerContainer: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginHorizontal: 10,
        gap: 10,
        marginVertical: 8,
        alignItems: "center"
    },
    searchWrapper: {
        flex: 1
    },
    filterButton: {
        flex: undefined,
        backgroundColor: theme.lightBackgroundColor,
        justifyContent: "center",
        alignItems: "center"
    },
    filterBadge: {
        position: "absolute",
        top: -2,
        right: -4,
        aspectRatio: 1,
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme.primary,
        height: 19,
        borderRadius: 9999,
    },
    locationButtonContainer: {
        flexDirection: 'row',
        alignItems: "center",
        gap: 10
    },
    listContainer: {
        flex: 1,
    },
    fabButton: {
        position: "absolute",
        backgroundColor: theme.primary,
        width: 56,
        height: 56,
        borderRadius: 28,
        bottom: 20,
        right: 20,
        justifyContent: 'center',
        alignItems: 'center',
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 3 },
        shadowOpacity: 0.2,
        shadowRadius: 5,
        elevation: 5,
    },
    locationPopoverView: {
        backgroundColor: theme.lightBackgroundColor,
        height: 350,
    },
    locationHeader: {
        flexDirection: 'row',
        paddingHorizontal: 10,
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: theme.light,
        paddingVertical: 10
    },
    locationSearchContainer: {
        marginVertical: 5
    },
    locationItem: {
        paddingHorizontal: 10,
        flexDirection: 'row',
        paddingVertical: 7,
        marginVertical: 10,
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: theme?.light,
        marginHorizontal: 15,
        borderRadius: 7
    },
    locationItemInner: {
        flexDirection: 'row',
        alignItems: 'center'
    },
    renderItemContainer: {
        marginBottom: 12,
        marginHorizontal: 12,
        elevation: 2,
        padding: 14,
        borderRadius: 16,
        backgroundColor: theme.light,
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.05,
        shadowRadius: 8,
    },
    renderItemHeader: {
        flex: 1,
        justifyContent: "space-between",
        flexDirection: "row",
    },
    renderItemName: {
        flex: 0.7,
        alignItems: "center",
        flexDirection: "row",
        gap: 10,
    },
    renderItemActions: {
        alignItems: "flex-end",
        gap: 10,
        flexDirection: "row"
    },
    actionButton: {
        backgroundColor: theme.lightBackgroundColor,
        padding: 4,
        borderRadius: 5
    },
    renderItemDetails: {
        flex: 1,
        justifyContent: "space-between",
        backgroundColor: theme.light,
        gap: 10,
        flexDirection: "row"
    },
    popoverStyle: {
        borderRadius: 10
    },
    dividerStyle: {
        marginHorizontal: 2,
        marginVertical: 5
    },
    emailContainer: {
        flex: 0.3
    },
    phoneContainer: {
        flex: 0.15
    },
    roleContainer: {
        flex: 0.1,
    },
    iconActionContainer: {
        flex: 0.4,
        justifyContent: "center",
        width: 30,
        alignItems: "center"
    },
    iconActionButton: {
        backgroundColor: theme.lightBackgroundColor,
        borderRadius: 5,
        padding: 8
    },
    searchContainerStyle: {
        backgroundColor: theme.light,
        paddingHorizontal: 10,
        borderRadius: 20,
        height: 48,
    },
    searchInputStyle: {
        color: theme.lightDark,
        fontSize: theme.smallFontSize,
        fontFamily: theme.medium,
        paddingLeft: 15
    },
    filterCountText: {
        color: theme.light
    },
    buttonStyle: {
        borderRadius: 7
    },
    addStaffButtonStyle: {
        borderRadius: 7,
        backgroundColor: theme?.primary,
    },
    listFooter: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center"
    },
    popoverLocation: {

    },
    locationSearchInputContainer: {
        height: 50,
        backgroundColor: theme.light,
        marginHorizontal: 10,
        borderRadius: 10
    },
    itemActionContainer: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        marginTop: 4,
        paddingTop: 10,
        // borderTopWidth: 0.5,
        // borderTopColor: theme.borderColor,
        columnGap: 10
    },
    actionButtonEdit: {
        padding: 9,
        backgroundColor: theme.lightPrimary,
        borderRadius: 20,
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 1,
        borderColor: "rgba(0, 83, 116, 0.08)",
        minWidth: 38,
        minHeight: 38,
    },
    actionButtonHistory: {
        padding: 9,
        backgroundColor: "#EAF6E3",
        borderRadius: 20,
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 1,
        borderColor: "rgba(12, 168, 90, 0.08)",
        minWidth: 38,
        minHeight: 38,
    },
    actionButtonStatus: {
        padding: 9,
        backgroundColor: "#FFF4EB",
        borderRadius: 20,
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 1,
        borderColor: "rgba(255, 133, 23, 0.08)",
        minWidth: 38,
        minHeight: 38,
    },
    actionButtonTarget: {
        padding: 9,
        backgroundColor: "#F5ECF5",
        borderRadius: 20,
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 1,
        borderColor: "rgba(173, 99, 158, 0.08)",
        minWidth: 38,
        minHeight: 38,
    },
    actionButtonDelete: {
        padding: 9,
        backgroundColor: "#FEF2F2",
        borderRadius: 20,
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 1,
        borderColor: "rgba(215, 44, 12, 0.08)",
        minWidth: 38,
        minHeight: 38,
    },
    detailRow: {
        flexDirection: "row",
        alignItems: "center",
    },
    itemActionContainerPortrait: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        marginTop: 12,
        paddingTop: 12,
        borderTopWidth: 1,
        borderTopColor: "#F1F5F9",
    },
})
